const admin = (state = {}, action) => {
  return {
    ...state,
    ...action,
  }
};

export default admin;


// WEBPACK FOOTER //
// ./src/reducers/admin.js